const initFreightCalculator = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(/* webpackChunkName: "CocktailsList" */ 'containers/FreightCalculatorContainer'),
  ]).then(
    ([{ default: React }, { default: ReactDOM }, ReactRedux, Store, LocalStorage, { default: FreightCalculator }]) => {
      const { Provider } = ReactRedux
      const { store } = Store
      const { LS } = LocalStorage

      ReactDOM.render(
        <Provider store={store}>
          <FreightCalculator LS={LS} />
        </Provider>,
        freightCalculator
      )
    }
  )
}

const initThreePlAdvancedShippingNotice = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(/* webpackChunkName: "ThreePlShippingNoticeList" */ '3pl/containers/ThreePlShippingNoticeListContainer'),
  ]).then(
    ([
      { default: React },
      { default: ReactDOM },
      ReactRedux,
      Store,
      LocalStorage,
      { default: ThreePlShippingNoticeList },
    ]) => {
      const { Provider } = ReactRedux
      const { store } = Store
      const { LS } = LocalStorage

      ReactDOM.render(
        <Provider store={store}>
          <ThreePlShippingNoticeList LS={LS} />
        </Provider>,
        threePlAdvancedShippingNotice
      )
    }
  )
}

const initThreePlAdvancedShippingNoticeAdd = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(/* webpackChunkName: "ThreePlShippingNotice" */ '3pl/containers/ThreePlShippingNoticeContainer'),
  ]).then(
    ([
      { default: React },
      { default: ReactDOM },
      ReactRedux,
      Store,
      LocalStorage,
      { default: ThreePlShippingNotice },
    ]) => {
      const { Provider } = ReactRedux
      const { store } = Store
      const { LS } = LocalStorage

      ReactDOM.render(
        <Provider store={store}>
          <ThreePlShippingNotice LS={LS} />
        </Provider>,
        threePlAdvancedShippingNoticeAdd
      )
    }
  )
}

const initThreePlAdvancedShippingNoticeView = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(/* webpackChunkName: "ThreePlShippingNoticeView" */ '3pl/containers/ThreePlShippingNoticeViewContainer'),
  ]).then(
    ([
      { default: React },
      { default: ReactDOM },
      ReactRedux,
      Store,
      LocalStorage,
      { default: ThreePlShippingNoticeView },
    ]) => {
      const { Provider } = ReactRedux
      const { store } = Store
      const { LS } = LocalStorage

      ReactDOM.render(
        <Provider store={store}>
          <ThreePlShippingNoticeView LS={LS} />
        </Provider>,
        threePlAdvancedShippingNoticeView
      )
    }
  )
}

const initThreePlSupplierWeeklyOrderStats = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(/* webpackChunkName: "OrderStatusWeekView" */ '3pl/containers/OrderStatusWeekViewContainer'),
  ]).then(
    ([
      { default: React },
      { default: ReactDOM },
      ReactRedux,
      Store,
      LocalStorage,
      { default: OrderStatusWeekView },
    ]) => {
      const { Provider } = ReactRedux
      const { store } = Store
      const { LS } = LocalStorage

      ReactDOM.render(
        <Provider store={store}>
          <OrderStatusWeekView LS={LS} />
        </Provider>,
        threePlSupplierWeeklyOrderStats
      )
    }
  )
}

const initTransactionDetailInvoice = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(
      /* webpackChunkName: "TransactionDetailInvoiceReport" */ '3pl/containers/TransactionDetailInvoiceReportContainer'
    ),
  ]).then(
    ([
      { default: React },
      { default: ReactDOM },
      ReactRedux,
      Store,
      LocalStorage,
      { default: TransactionDetailInvoiceReport },
    ]) => {
      const { Provider } = ReactRedux
      const { store } = Store
      const { LS } = LocalStorage

      ReactDOM.render(
        <Provider store={store}>
          <TransactionDetailInvoiceReport LS={LS} />
        </Provider>,
        transactionDetailInvoice
      )
    }
  )
}

const initBillingDetailsReport = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(/* webpackChunkName: "BillingDetailsReport" */ '3pl/containers/BillingDetailsReportContainer'),
  ]).then(
    ([
      { default: React },
      { default: ReactDOM },
      ReactRedux,
      Store,
      LocalStorage,
      { default: BillingDetailsReport },
    ]) => {
      const { Provider } = ReactRedux
      const { store } = Store
      const { LS } = LocalStorage

      ReactDOM.render(
        <Provider store={store}>
          <BillingDetailsReport LS={LS} />
        </Provider>,
        billingChargesDetails
      )
    }
  )
}

const initThreePlCreditTransactionDetails = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(
      /* webpackChunkName: "ThreePlTransactionDetailsReport" */ '3pl/containers/ThreePlTransactionDetailsReportContainer'
    ),
  ]).then(
    ([
      { default: React },
      { default: ReactDOM },
      ReactRedux,
      Store,
      LocalStorage,
      { default: ThreePlTransactionDetailsReport },
    ]) => {
      const { Provider } = ReactRedux
      const { store } = Store
      const { LS } = LocalStorage

      ReactDOM.render(
        <Provider store={store}>
          <ThreePlTransactionDetailsReport LS={LS} />
        </Provider>,
        threePlCreditTransactionDetails
      )
    }
  )
}

const initThreePlAdvancedShippingNoticeEdit = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(/* webpackChunkName: "ThreePlShippingNoticeEdit" */ '3pl/containers/ThreePlShippingNoticeEditContainer'),
  ]).then(
    ([
      { default: React },
      { default: ReactDOM },
      ReactRedux,
      Store,
      LocalStorage,
      { default: ThreePlShippingNoticeEdit },
    ]) => {
      const { Provider } = ReactRedux
      const { store } = Store
      const { LS } = LocalStorage

      ReactDOM.render(
        <Provider store={store}>
          <ThreePlShippingNoticeEdit LS={LS} />
        </Provider>,
        threePlAdvancedShippingNoticeEdit
      )
    }
  )
}

const initThreePlOrders = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(/* webpackChunkName: "CocktailsList" */ '3pl/containers/ThreePlMyOrdersContainer'),
  ]).then(
    ([{ default: React }, { default: ReactDOM }, ReactRedux, Store, LocalStorage, { default: ThreePlMyOrders }]) => {
      const { Provider } = ReactRedux
      const { store } = Store
      const { LS } = LocalStorage

      ReactDOM.render(
        <Provider store={store}>
          <ThreePlMyOrders LS={LS} />
        </Provider>,
        threePlMyOrder
      )
    }
  )
}

const initThreePlFreightCalculator = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(/* webpackChunkName: "ThreePlFreightCalculator" */ '3pl/containers/ThreePlFreightCalculatorContainer'),
  ]).then(
    ([
      { default: React },
      { default: ReactDOM },
      ReactRedux,
      Store,
      LocalStorage,
      { default: ThreePlFreightCalculator },
    ]) => {
      const { Provider } = ReactRedux
      const { store } = Store
      const { LS } = LocalStorage

      ReactDOM.render(
        <Provider store={store}>
          <ThreePlFreightCalculator LS={LS} />
        </Provider>,
        threePlFreightCalculator
      )
    }
  )
}

const initCocktailsList = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(/* webpackChunkName: "CocktailsList" */ 'containers/CocktailsListContainer'),
  ]).then(
    ([{ default: React }, { default: ReactDOM }, ReactRedux, Store, LocalStorage, { default: CocktailsList }]) => {
      const { Provider } = ReactRedux
      const { store } = Store
      const { LS } = LocalStorage

      ReactDOM.render(
        <Provider store={store}>
          <CocktailsList LS={LS} />
        </Provider>,
        cocktailsList
      )
    }
  )
}
const initOrderTemplate = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(/* webpackChunkName: "OrderTemplate" */ 'containers/OrderTemplateContainer'),
  ]).then(
    ([{ default: React }, { default: ReactDOM }, ReactRedux, Store, LocalStorage, { default: OrderTemplate }]) => {
      const { Provider } = ReactRedux
      const { store } = Store
      const { LS } = LocalStorage

      ReactDOM.render(
        <Provider store={store}>
          <OrderTemplate LS={LS} />
        </Provider>,
        orderTemplate
      )
    }
  )
}

const initQuoteTemplateList = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(/* webpackChunkName: "QuoteTemplateList" */ 'containers/QuoteTemplateListContainer'),
  ]).then(
    ([{ default: React }, { default: ReactDOM }, ReactRedux, Store, LocalStorage, { default: QuoteTemplateList }]) => {
      const { Provider } = ReactRedux
      const { store } = Store
      const { LS } = LocalStorage

      ReactDOM.render(
        <Provider store={store}>
          <QuoteTemplateList LS={LS} />
        </Provider>,
        quoteTemplateList
      )
    }
  )
}

const initProductsList = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(/* webpackChunkName: "ProductsList" */ 'containers/ProductsListContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, LocalStorage, { default: ProductsList }]) => {
    const { Provider } = ReactRedux
    const { store } = Store
    const { LS } = LocalStorage

    ReactDOM.render(
      <Provider store={store}>
        <ProductsList LS={LS} />
      </Provider>,
      productsList
    )
  })
}

const initProductsLoyaltyListPerPage = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(/* webpackChunkName: "ProductsListPerPage" */ 'containers/ProductLoyaltyContainer'),
    import(/* webpackChunkName: "ProductsPerPageActions" */ 'actions/productsPerPageActions'),
  ]).then(
    ([
      { default: React },
      { default: ReactDOM },
      ReactRedux,
      Store,
      LocalStorage,
      { default: ProductsListLoyalty },
      ProductsPerPageActions,
    ]) => {
      const { Provider } = ReactRedux
      const { store } = Store
      const { LS } = LocalStorage
      const { requestFilters } = ProductsPerPageActions

      Promise.all([store.dispatch(requestFilters())]).then(() => {
        ReactDOM.render(
          <Provider store={store}>
            <ProductsListLoyalty LS={LS} />
          </Provider>,
          productsListLoyalty
        )
      })
    }
  )
}

const initProductsListPerPage = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(/* webpackChunkName: "ProductsListPerPage" */ 'containers/ProductsListPerPageContainer'),
    import(/* webpackChunkName: "ProductsPerPageActions" */ 'actions/productsPerPageActions'),
  ]).then(
    ([
      { default: React },
      { default: ReactDOM },
      ReactRedux,
      Store,
      LocalStorage,
      { default: ProductsListPerPage },
      ProductsPerPageActions,
    ]) => {
      const { Provider } = ReactRedux
      const { store } = Store
      const { LS } = LocalStorage
      const { requestFilters } = ProductsPerPageActions

      Promise.all([store.dispatch(requestFilters())]).then(() => {
        ReactDOM.render(
          <Provider store={store}>
            <ProductsListPerPage LS={LS} />
          </Provider>,
          productsListPerPage
        )
      })
    }
  )
}
const initProductsListSearchPage = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(/* webpackChunkName: "ProductsListPerPage" */ 'containers/ProductsListPerPageContainer'),
    import(/* webpackChunkName: "ProductsPerPageActions" */ 'actions/productsPerPageActions'),
  ]).then(
    ([
      { default: React },
      { default: ReactDOM },
      ReactRedux,
      Store,
      LocalStorage,
      { default: ProductsListPerPage },
      ProductsPerPageActions,
    ]) => {
      const { Provider } = ReactRedux
      const { store } = Store
      const { LS } = LocalStorage
      const { requestFilters } = ProductsPerPageActions

      Promise.all([store.dispatch(requestFilters())]).then(() => {
        ReactDOM.render(
          <Provider store={store}>
            <ProductsListPerPage LS={LS} />
          </Provider>,
          productsListSearchPage
        )
      })
    }
  )
}

const initProductSlider = (productSliderList, datasetBlockId) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "ConnectedReactRouter" */ 'connected-react-router'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(/* webpackChunkName: "ProductCarousel" */ 'containers/ProductSliderContainer'),
    import(/* webpackChunkName: "ProductsPerPageActions" */ 'actions/productsPerPageActions'),
  ]).then(
    ([
      { default: React },
      { default: ReactDOM },
      ReactRedux,
      ConnectedReactRouter,
      Store,
      LocalStorage,
      { default: ProductSliderList },
    ]) => {
      const { Provider } = ReactRedux
      const { ConnectedRouter } = ConnectedReactRouter
      const { history, store } = Store

      ReactDOM.render(
        <Provider store={store}>
          <ProductSliderList datasetBlockId={datasetBlockId} />
        </Provider>,
        productSliderList
      )
    }
  )
}

const initProductCarousel = (productCarousel, datasetBlockId) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "ConnectedReactRouter" */ 'connected-react-router'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(/* webpackChunkName: "ProductCarousel" */ 'containers/ProductCarouselContainer'),
    import(/* webpackChunkName: "ProductsPerPageActions" */ 'actions/productsPerPageActions'),
  ]).then(
    ([
      { default: React },
      { default: ReactDOM },
      ReactRedux,
      ConnectedReactRouter,
      Store,
      LocalStorage,
      { default: ProductCarousel },
    ]) => {
      const { Provider } = ReactRedux
      const { ConnectedRouter } = ConnectedReactRouter
      const { history, store } = Store

      ReactDOM.render(
        <Provider store={store}>
          <ProductCarousel datasetBlockId={datasetBlockId} />
        </Provider>,
        productCarousel
      )
    }
  )
}

const initEventEnquirySignup = () => {
  if (eventEnquirySignup) {
    Promise.all([
      import(/* webpackChunkName: "React" */ 'react'),
      import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
      import(
        /* webpackChunkName: "WholesalerRegistrationForm" */ '../main/components/EventEnquirySignup/EventEnquirySignup'
      ),
    ]).then(([{ default: React }, { default: ReactDOM }, { default: EventEnquirySignup }]) => {
      ReactDOM.render(<EventEnquirySignup />, eventEnquirySignup)
    })
  }
}

const initFeaturedProductList = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(/* webpackChunkName: "FeaturedProductList" */ 'containers/FeaturedProductListContainer'),
  ]).then(
    ([
      { default: React },
      { default: ReactDOM },
      ReactRedux,
      Store,
      LocalStorage,
      { default: FeaturedProductList },
    ]) => {
      const { Provider } = ReactRedux
      const { store } = Store
      const { LS } = LocalStorage

      ReactDOM.render(
        <Provider store={store}>
          <FeaturedProductList LS={LS} />
        </Provider>,
        featuredProductList
      )
    }
  )
}
const initProductsFilters = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(/* webpackChunkName: "ProductsFiltersTop" */ 'containers/ProductsFiltersTopContainer'),
    import(/* webpackChunkName: "ProductsFiltersBottom" */ 'containers/ProductsFiltersBottomContainer'),
  ]).then(
    ([
      { default: React },
      { default: ReactDOM },
      ReactRedux,
      Store,
      LocalStorage,
      { default: ProductsFiltersTop },
      { default: ProductsFiltersBottom },
    ]) => {
      const { Provider } = ReactRedux
      const { store } = Store
      const { LS } = LocalStorage

      if (typeof productsFiltersTop != 'undefined' && productsFiltersTop) {
        ReactDOM.render(
          <Provider store={store}>
            <ProductsFiltersTop LS={LS} />
          </Provider>,
          productsFiltersTop
        )
      }
      if (typeof productsFiltersBottom != 'undefined' && productsFiltersBottom) {
        ReactDOM.render(
          <Provider store={store}>
            <ProductsFiltersBottom LS={LS} />
          </Provider>,
          productsFiltersBottom
        )
      }
    }
  )
}
const initProductsPerPageFilters = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(/* webpackChunkName: "ProductsPerPageFilters" */ 'containers/ProductsPerPageFiltersContainer'),
    import(/* webpackChunkName: "ProductsPerPageFiltersTop" */ 'containers/ProductsPerPageFiltersTopContainer'),
    import(/* webpackChunkName: "ProductsPerPageFiltersBottom" */ 'containers/ProductsPerPageFiltersBottomContainer'),
  ]).then(
    ([
      { default: React },
      { default: ReactDOM },
      ReactRedux,
      Store,
      LocalStorage,
      { default: ProductsPerPageFilters },
      { default: ProductsPerPageFiltersTop },
      { default: ProductsPerPageFiltersBottom },
    ]) => {
      const { Provider } = ReactRedux
      const { store } = Store
      const { LS } = LocalStorage

      if (typeof productsPerPageFilters != 'undefined' && productsPerPageFilters) {
        ReactDOM.render(
          <Provider store={store}>
            <ProductsPerPageFilters LS={LS} />
          </Provider>,
          productsPerPageFilters
        )
      }
      if (typeof productsPerPageFiltersTop != 'undefined' && productsPerPageFiltersTop) {
        ReactDOM.render(
          <Provider store={store}>
            <ProductsPerPageFiltersTop LS={LS} />
          </Provider>,
          productsPerPageFiltersTop
        )
      }
      if (typeof productsPerPageFiltersBottom != 'undefined' && productsPerPageFiltersBottom) {
        ReactDOM.render(
          <Provider store={store}>
            <ProductsPerPageFiltersBottom LS={LS} />
          </Provider>,
          productsPerPageFiltersBottom
        )
      }
    }
  )
}
const initProductGridTabs = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(/* webpackChunkName: "ProductGridTabs" */ 'containers/ProductGridTabsContainer'),
  ]).then(
    ([{ default: React }, { default: ReactDOM }, ReactRedux, Store, LocalStorage, { default: ProductGridTabs }]) => {
      const { Provider } = ReactRedux
      const { store } = Store
      const { LS } = LocalStorage

      ReactDOM.render(
        <Provider store={store}>
          <ProductGridTabs LS={LS} />
        </Provider>,
        productGridTabs
      )
    }
  )
}
const initPaymentsHistory = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "PaymentsHistory" */ 'containers/PaymentsHistoryContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: PaymentsHistory }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <PaymentsHistory />
      </Provider>,
      paymentsHistoryList
    )
  })
}
const initPayments = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "Payments" */ 'containers/PaymentsContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: Payments }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <Payments />
      </Provider>,
      payments
    )
  })
}
const initViewStatementPdf = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "Payments" */ 'containers/PdfStatementContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: StatementModal }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <StatementModal />
      </Provider>,
      viewStatementPdf
    )
  })
}
const initCocktailProductsList = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "CocktailProductsList" */ 'containers/CocktailProductsListContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: CocktailProductsList }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <CocktailProductsList />
      </Provider>,
      cocktailProductsList
    )
  })
}
const initProductForm = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "ProductForm" */ 'containers/ProductFormContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: ProductForm }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <ProductForm />
      </Provider>,
      productForm
    )
  })
}
const initInvoices = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "Invoices" */ 'containers/InvoicesContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: Invoices }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <Invoices />
      </Provider>,
      invoices
    )
  })
}
const initOrders = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "Orders" */ 'containers/OrdersContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: Orders }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <Orders />
      </Provider>,
      orders
    )
  })
}
const initOrderModal = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "OrderModal" */ 'containers/OrderModalContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: OrderModal }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <OrderModal />
      </Provider>,
      orderModal
    )
  })
}
const initInvoiceModal = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "InvoiceModal" */ 'containers/InvoiceModalContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: InvoiceModal }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <InvoiceModal />
      </Provider>,
      invoiceModal
    )
  })
}
const initReports = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "Reports" */ 'containers/ReportsContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: Reports }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <Reports />
      </Provider>,
      reports
    )
  })
}
const initCocktailsModal = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "CocktailsModal" */ 'containers/CocktailsModalContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: CocktailsModal }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <CocktailsModal />
      </Provider>,
      cocktailsModal
    )
  })
}
const initReplacementsModal = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "ReplacementsModal" */ 'containers/ReplacementsModalContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: ReplacementsModal }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <ReplacementsModal />
      </Provider>,
      replacementsModal
    )
  })
}
const initCart = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "Cart" */ 'containers/CartContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: Cart }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <Cart />
      </Provider>,
      cart
    )
  })
}

const initLoyaltyPopup = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
    import(/* webpackChunkName: "LoyaltyPopup" */ 'containers/LoyaltyPopupContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, LocalStorage, { default: LoyaltyPopup }]) => {
    const { Provider } = ReactRedux
    const { store } = Store
    const { LS } = LocalStorage

    ReactDOM.render(
      <Provider store={store}>
        <LoyaltyPopup LS={LS} />
      </Provider>,
      loyaltyPopup
    )
  })
}
const initUserUpdatePopup = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "UserUpdatePopup" */ 'containers/UserUpdatePopupContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: UserUpdatePopup }]) => {
    const { Provider } = ReactRedux
    const { store } = Store
    ReactDOM.render(
      <Provider store={store}>
        <UserUpdatePopup container={userUpdatePopupCustomer} />
      </Provider>,
      userUpdatePopupCustomer
    )
  })
}
const initCartSupplier = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "CartSupplier" */ 'containers/CartSupplierContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: CartSupplier }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <CartSupplier />
      </Provider>,
      cartSupplier
    )
  })
}
const initCart3PL = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "Cart3PL" */ 'containers/Cart3PLContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: Cart3PL }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <Cart3PL />
      </Provider>,
      cart3PL
    )
  })
}
const initBackOrder = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "BackOrder" */ 'containers/BackOrderContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: BackOrder }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <BackOrder />
      </Provider>,
      backOrder
    )
  })
}
const initCartCounter = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "CartCounter" */ 'containers/CartCounterContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: CartCounter }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    cartCounter.forEach((el) =>
      ReactDOM.render(
        <Provider store={store}>
          <CartCounter container={el} />
        </Provider>,
        el
      )
    )
  })
}
const initCartCounterSupplier = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "CartCounterSupplier" */ 'containers/CartCounterSupplierContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: CartCounterSupplier }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    cartCounterSupplier.forEach((el) =>
      ReactDOM.render(
        <Provider store={store}>
          <CartCounterSupplier container={el} />
        </Provider>,
        el
      )
    )
  })
}
const initCartCounter3PL = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "CartCounter3PL" */ 'containers/CartCounter3PLContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: CartCounter3PL }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    cartCounter3PL.forEach((el) =>
      ReactDOM.render(
        <Provider store={store}>
          <CartCounter3PL container={el} />
        </Provider>,
        el
      )
    )
  })
}
const initBackOrderCounter = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "BackOrderCounter" */ 'containers/BackOrderCounterContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: BackOrderCounter }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    backOrderCounter.forEach((el) =>
      ReactDOM.render(
        <Provider store={store}>
          <BackOrderCounter container={el} />
        </Provider>,
        el
      )
    )
  })
}

// Promise.all([
//   import(/* webpackChunkName: "React" */ 'react'),
//   import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
//   import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
//   import(/* webpackChunkName: "Store" */ 'store/store'),
//   import(/* webpackChunkName: "ProductMaintenanceList" */ 'containers/ProductMaintenanceListContainer'),
// ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: ProductMaintenanceList }]) => {
//   const { Provider } = ReactRedux
//   const { store } = Store
//
//   ReactDOM.render(
//     <Provider store={store}>
//       <ProductMaintenanceList container={productMaintenanceList} />
//     </Provider>,
//     productMaintenanceList
//   )
// })

const initProductMaintenanceList = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "ThreePlProductMaintenanceList" */ '3pl/containers/ThreePlProductMaintenanceContainer'),
  ]).then(
    ([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: ThreePlProductMaintenanceList }]) => {
      const { Provider } = ReactRedux
      const { store } = Store

      ReactDOM.render(
        <Provider store={store}>
          <ThreePlProductMaintenanceList container={productMaintenanceList} />
        </Provider>,
        productMaintenanceList
      )
    }
  )
}

const init3PLProductMaintenanceList = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "ThreePlProductMaintenanceList" */ '3pl/containers/ThreePlProductMaintenanceContainer'),
  ]).then(
    ([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: ThreePlProductMaintenanceList }]) => {
      const { Provider } = ReactRedux
      const { store } = Store

      ReactDOM.render(
        <Provider store={store}>
          <ThreePlProductMaintenanceList container={threeplproductMaintenanceList} />
        </Provider>,
        threeplproductMaintenanceList
      )
    }
  )
}

const init3PLCustomersList = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "ThreePlCustomersList" */ '3pl/containers/ThreePlCustomersContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: ThreePlCustomersList }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <ThreePlCustomersList container={threeplCustomersList} />
      </Provider>,
      threeplCustomersList
    )
  })
}

const init3PLStockOnHandList = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "ThreePlStockOnHandListContainer" */ '3pl/containers/ThreePlStockOnHandListContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: ThreePlStockOnHandList }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <ThreePlStockOnHandList container={threeplstockOnHandList} />
      </Provider>,
      threeplstockOnHandList
    )
  })
}

const init3PLAtRiskStockList = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "ThreePlAtRiskStockListContainer" */ '3pl/containers/ThreePlAtRiskStockListContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: ThreePlAtRiskStockList }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <ThreePlAtRiskStockList container={threeplatRiskStockList} />
      </Provider>,
      threeplatRiskStockList
    )
  })
}

const init3PLCreditAccountList = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(
      /* webpackChunkName: "ThreePlCreditAccountListContainer" */ '3pl/containers/ThreePlCreditAccountListContainer'
    ),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: ThreePlCreditAccountList }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <ThreePlCreditAccountList container={threeplcreditAccountList} />
      </Provider>,
      threeplcreditAccountList
    )
  })
}

const init3PLSubmittedDealList = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "axios" */ 'axios'),
    import(
      /* webpackChunkName: "ThreePlSubmittedDealListContainer" */ '3pl/containers/ThreePlSubmittedDealListContainer'
    ),
  ]).then(
    ([
      { default: React },
      { default: ReactDOM },
      ReactRedux,
      Store,
      { default: axios },
      { default: ThreePlSubmittedDealList },
    ]) => {
      const { Provider } = ReactRedux
      const { store } = Store

      ReactDOM.render(
        <Provider store={store}>
          <ThreePlSubmittedDealList container={threeplsubmittedDealList} />
        </Provider>,
        threeplsubmittedDealList
      )
    }
  )
}

const initProductMaintenanceModalEdit = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "ProductMaintenanceModalEdit" */ 'containers/ProductMaintenanceModalEditContainer'),
  ]).then(
    ([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: ProductMaintenanceModalEdit }]) => {
      const { Provider } = ReactRedux
      const { store } = Store

      ReactDOM.render(
        <Provider store={store}>
          <ProductMaintenanceModalEdit container={productMaintenanceModalEdit} />
        </Provider>,
        productMaintenanceModalEdit
      )
    }
  )
}
const initProductMaintenanceModalAdd = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "ProductMaintenanceModalAdd" */ 'containers/ProductMaintenanceModalAddContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: ProductMaintenanceModalAdd }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <ProductMaintenanceModalAdd container={productMaintenanceModalAdd} />
      </Provider>,
      productMaintenanceModalAdd
    )
  })
}

const initThreePlProductMaintenanceAdd = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "NewProductMaintenancePage" */ '3pl/containers/NewProductMaintenanceContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: NewProductMaintenancePage }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <NewProductMaintenancePage container={threePlProductMaintenanceAdd} />
      </Provider>,
      threePlProductMaintenanceAdd
    )
  })
}

const initDiscounts = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "Discounts" */ 'containers/DiscountsContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: Discounts }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <Discounts container={discountsList} />
      </Provider>,
      discountsList
    )
  })
}
const initDiscountForm = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "DiscountForm" */ 'containers/DiscountFormContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: DiscountForm }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <DiscountForm container={discountForm} />
      </Provider>,
      discountForm
    )
  })
}
const initDiscountModal = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "DiscountModal" */ 'containers/DiscountModalContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: DiscountModal }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <DiscountModal container={discountModal} />
      </Provider>,
      discountModal
    )
  })
}
const initPromotionForm = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "PromotionForm" */ 'containers/PromotionFormContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: PromotionForm }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <PromotionForm container={promotionForm} />
      </Provider>,
      promotionForm
    )
  })
}
const initPromotionList = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "PromotionList" */ 'containers/PromotionListContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: PromotionList }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <PromotionList container={promotionList} />
      </Provider>,
      promotionList
    )
  })
}
const initDealBuilderForm = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "DealBuilderForm" */ 'containers/DealBuilderFormContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: DealBuilderForm }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <DealBuilderForm container={dealBuilderForm} />
      </Provider>,
      dealBuilderForm
    )
  })
}
const initDealBuilderList = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "DealBuilderList" */ 'containers/DealBuilderListContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: DealBuilderList }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <DealBuilderList container={dealBuilderList} />
      </Provider>,
      dealBuilderList
    )
  })
}

const initDealBuilderEdit = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "DealBuilderForm" */ 'containers/DealBuilderEditContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: DealBuilderEdit }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <DealBuilderEdit container={dealBuilderEdit} />
      </Provider>,
      dealBuilderEdit
    )
  })
}
const initDealBuilderModal = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "DealBuilderModal" */ 'containers/DealBuilderModalContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: DealBuilderModal }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <DealBuilderModal container={dealBuilderModalView} />
      </Provider>,
      dealBuilderModalView
    )
  })
}
const initOngoingDeal = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "OngoingDeal" */ 'containers/OngoingDealContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: OngoingDeal }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <OngoingDeal container={ongoingDeal} />
      </Provider>,
      ongoingDeal
    )
  })
}
const initOngoingDealModal = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "OngoingDealModal" */ 'containers/OngoingDealModalContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: OngoingDealModal }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <OngoingDealModal container={ongoingDealModal} />
      </Provider>,
      ongoingDealModal
    )
  })
}
const initOrders3PL = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "Orders3PL" */ 'containers/Orders3PLContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: Orders3PL }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <Orders3PL container={orders3pl} />
      </Provider>,
      orders3pl
    )
  })
}
const initOrder3PLModal = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "Order3PLModal" */ 'containers/Order3PLModalContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: Order3PLModal }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <Order3PLModal />
      </Provider>,
      order3plModal
    )
  })
}

const initSearchSupplierForm = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "SearchSupplierForm" */ 'containers/SearchSupplierFormContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: SearchSupplierForm }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <SearchSupplierForm container={searchSupplierForm} />
      </Provider>,
      searchSupplierForm
    )
  })
}

const initSearchCustomerForm = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "SearchCustomerForm" */ 'containers/SearchCustomerFormContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: SearchCustomerForm }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <SearchCustomerForm container={searchCustomerForm} />
      </Provider>,
      searchCustomerForm
    )
  })
}

const initSearchCustomerForm3PL = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "SearchCustomerForm3PL" */ 'containers/SearchCustomerForm3PLContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: SearchCustomerForm3PL }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <SearchCustomerForm3PL container={searchCustomerForm3PL} />
      </Provider>,
      searchCustomerForm3PL
    )
  })
}
const initSearchCustomerFormSuperWholesaler = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(
      /* webpackChunkName: "SearchCustomerFormSuperWholesaler" */ 'containers/SearchCustomerFormSuperWholesalerContainer'
    ),
  ]).then(
    ([
      { default: React },
      { default: ReactDOM },
      ReactRedux,
      Store,
      { default: SearchCustomerFormSuperWholesaler },
    ]) => {
      const { Provider } = ReactRedux
      const { store } = Store

      ReactDOM.render(
        <Provider store={store}>
          <SearchCustomerFormSuperWholesaler container={searchCustomerFormSuperWholesaler} />
        </Provider>,
        searchCustomerFormSuperWholesaler
      )
    }
  )
}
const initCustomerBar = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "CustomerBar" */ 'containers/CustomerBarContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: CustomerBar }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <CustomerBar container={customerBar} />
      </Provider>,
      customerBar
    )
  })
}
const initCustomerBar3PL = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "CustomerBar3PL" */ 'containers/CustomerBar3PLContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: CustomerBar3PL }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <CustomerBar3PL container={customerBar3PL} />
      </Provider>,
      customerBar3PL
    )
  })
}
const initCustomerManagement = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "CustomerManagement" */ 'containers/CustomerManagementContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: CustomerManagement }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <CustomerManagement container={customerManagementList} />
      </Provider>,
      customerManagementList
    )
  })
}
const initProductsList3PL = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "ProductsList3PL" */ 'containers/ProductsList3PLContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: ProductsList3PL }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <ProductsList3PL container={productsList3PL} />
      </Provider>,
      productsList3PL
    )
  })
}
const initPlaceOrderButton3PL = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "PlaceOrderButton3PL" */ 'containers/PlaceOrderButton3PLContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: PlaceOrderButton3PL }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <PlaceOrderButton3PL container={placeOrderButton3PL} />
      </Provider>,
      placeOrderButton3PL
    )
  })
}
const initProductsListSupplier = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "ProductsListSupplier" */ 'containers/ProductsListSupplierContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: ProductsListSupplier }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <ProductsListSupplier container={productsListSupplier} />
      </Provider>,
      productsListSupplier
    )
  })
}
const initAddAllToOrderButton = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "AddAllToOrderButton" */ 'containers/AddAllToOrderButtonContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: AddAllToOrderButton }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <AddAllToOrderButton container={supplierAddAll} />
      </Provider>,
      supplierAddAll
    )
  })
}
const initCheckout = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "Checkout" */ 'containers/CheckoutContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: Checkout }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <Checkout container={checkout} />
      </Provider>,
      checkout
    )
  })
}
const initCheckoutSupplier = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "CheckoutSupplier" */ 'containers/CheckoutSupplierContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: CheckoutSupplier }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <CheckoutSupplier container={checkoutSupplier} />
      </Provider>,
      checkoutSupplier
    )
  })
}
const initCheckout3PL = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "Checkout3PL" */ 'containers/Checkout3PLContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: Checkout3PL }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <Checkout3PL container={checkout3pl} />
      </Provider>,
      checkout3pl
    )
  })
}
const initCheckoutConfirmDeliveryDate = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "CheckoutConfirmDeliveryDate" */ 'containers/CheckoutConfirmDeliveryDateContainer'),
  ]).then(
    ([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: CheckoutConfirmDeliveryDate }]) => {
      const { Provider } = ReactRedux
      const { store } = Store

      ReactDOM.render(
        <Provider store={store}>
          <CheckoutConfirmDeliveryDate container={checkoutConfirmDeliveryDate} />
        </Provider>,
        checkoutConfirmDeliveryDate
      )
    }
  )
}
const initOrderReceiptTable = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "OrderReceiptTable" */ 'containers/OrderReceiptTableContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: OrderReceiptTable }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <OrderReceiptTable container={orderReceiptTable} />
      </Provider>,
      orderReceiptTable
    )
  })
}
const initAccountListAddress = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "AccountListAddress" */ 'containers/AccountListAddressContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: AccountListAddress }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <AccountListAddress container={accountListAddress} />
      </Provider>,
      accountListAddress
    )
  })
}
const initAccountNewAddress = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "AccountNewAddress" */ 'containers/AccountNewAddressContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: AccountNewAddress }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <AccountNewAddress container={accountNewAddress} />
      </Provider>,
      accountNewAddress
    )
  })
}
const initAccountListCreditCard = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "AccountListCreditCard" */ 'containers/AccountListCreditCardContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: AccountListCreditCard }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <AccountListCreditCard container={accountListCreditCard} />
      </Provider>,
      accountListCreditCard
    )
  })
}
const initAccountNewCreditCard = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "AccountNewCreditCard" */ 'containers/AccountNewCreditCardContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: AccountNewCreditCard }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <AccountNewCreditCard container={accountNewCreditCard} />
      </Provider>,
      accountNewCreditCard
    )
  })
}
const initSupplierHistoryReport = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "SupplierHistoryReport" */ 'containers/SupplierHistoryReportContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: SupplierHistoryReport }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <SupplierHistoryReport container={supplierHistoryReport} />
      </Provider>,
      supplierHistoryReport
    )
  })
}
const initSupplierStockReport = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "ThreePlStockOnHandListContainer" */ '3pl/containers/ThreePlStockOnHandListContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: ThreePlStockOnHandList }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <ThreePlStockOnHandList container={supplierStockReport} />
      </Provider>,
      supplierStockReport
    )
  })
}

const initSupplierBinTransReport = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "TransBinReport" */ 'containers/TransBinReportContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: TransBinReport }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <TransBinReport container={supplierBinTransReport} />
      </Provider>,
      supplierBinTransReport
    )
  })
}

const initSupplierRateCard = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "SupplierRateCard" */ '3pl/containers/SupplierRateCardContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: SupplierRateCard }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <SupplierRateCard container={supplierRateCard} />
      </Provider>,
      supplierRateCard
    )
  })
}

const initSupplierRateCardList = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "SupplierRateCardList" */ '3pl/containers/SupplierRateCardListContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: SupplierRateCardList }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <SupplierRateCardList container={supplierRateCardList} />
      </Provider>,
      supplierRateCardList
    )
  })
}

// RCTI and Billing Reports
const initThreeplRctiDollarDailyCharge = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "DailyChargeReport" */ '3pl/containers/RCTIDailyChargeReportContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: DailyChargeReport }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <DailyChargeReport container={threeplRctiDollarDailyCharge} />
      </Provider>,
      threeplRctiDollarDailyCharge
    )
  })
}

const initThreeplBillingDollarCharge = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "DollarChargeBillingReport" */ '3pl/containers/DollarChargeBillingReportContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: DollarChargeBillingReport }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <DollarChargeBillingReport container={threeplBillingDollarCharge} />
      </Provider>,
      threeplBillingDollarCharge
    )
  })
}

const initThreeplRctiPercentageCharge = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "ThreeplPercentageReport" */ '3pl/containers/ThreeplPercentageRCTIReportContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: ThreeplPercentageReport }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <ThreeplPercentageReport container={threeplRctiPercentageCharge} />
      </Provider>,
      threeplRctiPercentageCharge
    )
  })
}

const initThreeplBillingPercentageCharge = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(
      /* webpackChunkName: "PercentageChargeBillingReport" */ '3pl/containers/PercentageChargeBillingReportContainer'
    ),
  ]).then(
    ([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: PercentageChargeBillingReport }]) => {
      const { Provider } = ReactRedux
      const { store } = Store

      ReactDOM.render(
        <Provider store={store}>
          <PercentageChargeBillingReport container={threeplBillingPercentageCharge} />
        </Provider>,
        threeplBillingPercentageCharge
      )
    }
  )
}

//////////////////////////////////////

const initThreeplSupplierPurchasesReport = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(
      /* webpackChunkName: "ThreeplSupplierPurchasesReport" */ '3pl/containers/ThreeplSupplierPurchasesReportContainer'
    ),
  ]).then(
    ([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: ThreeplSupplierPurchasesReport }]) => {
      const { Provider } = ReactRedux
      const { store } = Store

      ReactDOM.render(
        <Provider store={store}>
          <ThreeplSupplierPurchasesReport container={threeplSupplierPurchasesReport} />
        </Provider>,
        threeplSupplierPurchasesReport
      )
    }
  )
}

const initSupplierOutOfStockReport = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "SupplierOutOfStockReport" */ 'containers/SupplierOutOfStockReportContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: SupplierOutOfStockReport }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <SupplierOutOfStockReport container={supplierOutOfStockReport} />
      </Provider>,
      supplierOutOfStockReport
    )
  })
}

const initSupplierSalesReport = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "SupplierSalesReport" */ 'containers/SupplierSalesReportContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: SupplierSalesReport }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <SupplierSalesReport container={supplierSalesReport} />
      </Provider>,
      supplierSalesReport
    )
  })
}
const initSupplierSalesVenueReport = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "SupplierSalesVenueReport" */ 'containers/SupplierSalesVenueReportContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: SupplierSalesVenueReport }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <SupplierSalesVenueReport container={supplierSalesVenueReport} />
      </Provider>,
      supplierSalesVenueReport
    )
  })
}
const initBackorderDropdown = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "BackorderDropdown" */ 'containers/BackorderDropdownContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: BackorderDropdown }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <BackorderDropdown container={backorderDropdown} />
      </Provider>,
      backorderDropdown
    )
  })
}
const initDeliveryInformation = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "DeliveryInformation" */ 'containers/DeliveryInformationContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: DeliveryInformation }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <DeliveryInformation container={deliveryInformation} />
      </Provider>,
      deliveryInformation
    )
  })
}

const initBackorderSms = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "BackorderSms" */ 'containers/BackorderSmsContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: BackorderSms }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <BackorderSms container={backorderSms} />
      </Provider>,
      backorderSms
    )
  })
}

const initBackorderNotification = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "BackorderNotification" */ 'containers/BackorderNotificationContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: BackorderNotification }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <BackorderNotification container={backorderNotification} />
      </Provider>,
      backorderNotification
    )
  })
}
const initFeaturesDeals = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "FeatureDeals" */ 'containers/FeatureDealsContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: FeatureDeals }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <FeatureDeals container={featuresDeals} />
      </Provider>,
      featuresDeals
    )
  })
}

const initAccountPayable = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "AccountPayable" */ 'containers/AccountPayableContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: AccountPayable }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <AccountPayable container={accountPayable} />
      </Provider>,
      accountPayable
    )
  })
}

const initDeliveryPreferences = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "DeliveryPreferences" */ 'containers/DeliveryPreferencesContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: DeliveryPreferences }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <DeliveryPreferences container={deliveryPreferences} />
      </Provider>,
      deliveryPreferences
    )
  })
}
const initQuoteStatus = () => {
  if (quoteStatus) {
    Promise.all([
      import(/* webpackChunkName: "React" */ 'react'),
      import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
      import(/* webpackChunkName: "QuoteStatus" */ '../dashboard/components/QuoteStatus'),
    ]).then(([{ default: React }, { default: ReactDOM }, { default: QuoteStatus }]) => {
      ReactDOM.render(<QuoteStatus />, quoteStatus)
    })
  }
}

const initConfirmDeliveryPopup = () => {
  if (confirmDeliveryPopup) {
    Promise.all([
      import(/* webpackChunkName: "React" */ 'react'),
      import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
      import(/* webpackChunkName: "ConfirmDeliveryPopup" */ '../dashboard/components/ConfirmDeliveryPopup'),
    ]).then(([{ default: React }, { default: ReactDOM }, { default: ConfirmDeliveryPopup }]) => {
      ReactDOM.render(<ConfirmDeliveryPopup />, confirmDeliveryPopup)
    })
  }
}

const initCreateSaleQuote = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "OngoingDeal" */ 'containers/CreateSaleQuoteContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: CreateSaleQuote }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <CreateSaleQuote container={createSaleQuote} />
      </Provider>,
      createSaleQuote
    )
  })
}

const initEditSaleQuote = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "OngoingDeal" */ 'containers/EditSaleQuoteContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: EditSaleQuote }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <EditSaleQuote container={editSaleQuote} />
      </Provider>,
      editSaleQuote
    )
  })
}

const initEditSaleQuoteManager = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "OngoingDeal" */ 'containers/EditSaleQuoteManagerContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: EditSaleQuoteManager }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <EditSaleQuoteManager container={editSaleQuoteManager} />
      </Provider>,
      editSaleQuoteManager
    )
  })
}

const initProductDeals = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "ProductDeals" */ 'containers/ProductDealContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: ProductDeal }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <ProductDeal container={productDeal} />
      </Provider>,
      ProductDeal
    )
  })
}

const initDealButton = () => {
  if (dealBtn) {
    Promise.all([
      import(/* webpackChunkName: "React" */ 'react'),
      import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
      import(/* webpackChunkName: "QuoteStatus" */ '../dashboard/components/DealButton'),
    ]).then(([{ default: React }, { default: ReactDOM }, { default: DealButton }]) => {
      ReactDOM.render(<DealButton />, DealButton)
    })
  }
}

const initGoogleAddressChecker = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "GoogleAddressChecker" */ 'containers/GoogleAddressCheckerContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: GoogleAddressChecker }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <GoogleAddressChecker conatiner={googleAddressChecker} />
      </Provider>,
      googleAddressChecker
    )
  })
}

const initChartDocument = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "ChartWrapper" */ './components/ChartWrapper'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: ChartWrapper }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <ChartWrapper conatiner={chartDocument} />
      </Provider>,
      chartDocument
    )
  })
}

const initSurveyForm = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "SurveyForm" */ 'containers/SurveyFormContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: SurveyForm }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <SurveyForm conatiner={surveyForm} />
      </Provider>,
      surveyForm
    )
  })
}

const initMarketingSurveyForm = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "MarketingSurveyForm" */ 'containers/MarketingSurveyFormContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: MarketingSurveyForm }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <MarketingSurveyForm conatiner={marketingSurveyForm} />
      </Provider>,
      marketingSurveyForm
    )
  })
}

const initLoyaltyBoxModal = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "LoyaltyBoxModal" */ 'containers/LoyaltyBoxModalContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: LoyaltyBoxModal }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <LoyaltyBoxModal conatiner={loyaltyBoxModal} />
      </Provider>,
      loyaltyBoxModal
    )
  })
}

const initOutOfBusinessCustomer = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "OutOfBusinessPopup" */ 'containers/OutOfBusinessPopupContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: OutOfBusinessPopup }]) => {
    const { Provider } = ReactRedux
    const { store } = Store
    ReactDOM.render(
      <Provider store={store}>
        <OutOfBusinessPopup container={outOfBusinessCustomer} />
      </Provider>,
      outOfBusinessCustomer
    )
  })
}

const initQldCustomerFirstPopup = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "QldCustomerFirstPopup" */ 'containers/QldCustomerFirstPopupContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: QldCustomerFirstPopup }]) => {
    const { Provider } = ReactRedux
    const { store } = Store
    ReactDOM.render(
      <Provider store={store}>
        <QldCustomerFirstPopup container={qldCustomerFirstPopup} />
      </Provider>,
      qldCustomerFirstPopup
    )
  })
}

const initOrderConfirmationPage = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "OrderConfirmation" */ 'containers/OrderConfirmationContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: OrderConfirmation }]) => {
    const { Provider } = ReactRedux
    const { store } = Store

    ReactDOM.render(
      <Provider store={store}>
        <OrderConfirmation container={orderConfirmationPage} />
      </Provider>,
      orderConfirmationPage
    )
  })
}

const initWholesaleSupplierSubmitCPIReport = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(
      /* webpackChunkName: "WholesaleSupplierCPIReportContainer" */ '3pl/containers/WholesaleSupplierCPIReportContainer'
    ),
  ]).then(
    ([
      { default: React },
      { default: ReactDOM },
      ReactRedux,
      Store,
      { default: WholesaleSupplierCPIReportContainer },
    ]) => {
      const { Provider } = ReactRedux
      const { store } = Store

      ReactDOM.render(
        <Provider store={store}>
          <WholesaleSupplierCPIReportContainer container={wholesaleSupplierCPIReport} />
        </Provider>,
        wholesaleSupplierCPIReport
      )
    }
  )
}

const init3PLWholesaleSupplierSubmitCPIReport = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(
      /* webpackChunkName: "ThreePLSupplierCPIReportContainer" */ '3pl/containers/ThreePLSupplierCPIReportContainer'
    ),
  ]).then(
    ([
      { default: React },
      { default: ReactDOM },
      ReactRedux,
      Store,
      { default: ThreePLSupplierCPIReportContainer },
    ]) => {
      const { Provider } = ReactRedux
      const { store } = Store

      ReactDOM.render(
        <Provider store={store}>
          <ThreePLSupplierCPIReportContainer container={threePLSupplierCPIReport} />
        </Provider>,
        threePLSupplierCPIReport
      )
    }
  )
}
const initWholesaleSupplierInvoiceSearch = (params) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(
      /* webpackChunkName: "WholesaleSupplierInvoiceSearch" */ 'containers/WholesaleSupplierInvoiceSearchContainer'
    ),
  ]).then(
    ([
      { default: React },
      { default: ReactDOM },
      ReactRedux,
      Store,
      { default: WholesaleSupplierInvoiceSearchContainer },
    ]) => {
      const { Provider } = ReactRedux
      const { store } = Store

      ReactDOM.render(
        <Provider store={store}>
          <WholesaleSupplierInvoiceSearchContainer container={wholesaleSupplierInvoiceSearch} />
        </Provider>,
        wholesaleSupplierInvoiceSearch
      )
    }
  )
}

const initProductListingGridBlock = ({ productListingGridBlockItem, blockId, itemsLimit, productTilesJSON }) => {
  Promise.all([
    import(/* webpackChunkName: "React" */ 'react'),
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom'),
    import(/* webpackChunkName: "ReactRedux" */ 'react-redux'),
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "ProductListingGridBlock" */ 'containers/ProductListingGridBlockContainer'),
  ]).then(([{ default: React }, { default: ReactDOM }, ReactRedux, Store, { default: ProductListingGridBlock }]) => {
    const { Provider } = ReactRedux
    const { store } = Store
    ReactDOM.render(
      <Provider store={store}>
        <ProductListingGridBlock
          blockID={blockId}
          itemsLimit={itemsLimit}
          productTilesJSON={productTilesJSON}
          conatiner={productListingGridBlockItem}
        />
      </Provider>,
      productListingGridBlockItem
    )
  })
}

const initStore = () => {
  Promise.all([
    import(/* webpackChunkName: "Store" */ 'store/store'),
    import(/* webpackChunkName: "ProductsActions" */ 'actions/productsActions'),
    import(/* webpackChunkName: "UserActions" */ 'actions/userActions'),
    import(/* webpackChunkName: "CartActions" */ 'actions/cartActions'),
    import(/* webpackChunkName: "PermanentBackOrderActions" */ 'actions/permanentBackorderActions'),
    import(/* webpackChunkName: "CartSupplierActions" */ 'actions/cartSupplierActions'),
    import(/* webpackChunkName: "LocalStorage" */ 'store/localStorage'),
  ]).then(
    ([
      Store,
      ProductsActions,
      UserActions,
      CartActions,
      PermanentBackOrderActions,
      CartSupplierActions,
      LocalStorage,
    ]) => {
      const { store } = Store
      // const { getCategoryID } = ProductsActions;
      const { getUserCredentials, getUserWarehouseCode, getGlobalConfig } = UserActions
      const { initializeSelectedFilters, requestProductRules } = ProductsActions
      const {
        handleAppVersioning,
        getProductsFromStorage,
        saveProductsToStorage,
        getCategoriesFromStorage,
        saveCategoriesToStorage,
        getCartFromStorage,
        saveCartToStorage,
        get3plActiveCustomerFromStorage,
        save3plActiveCustomerToStorage,
        getSupplierActiveCustomerFromStorage,
        saveSupplierActiveCustomerToStorage,
        getSupplierCartFromStorage,
        saveSupplierCartToStorage,
        get3plCartFromStorage,
        save3plCartToStorage,
      } = LocalStorage
      const { requestFromServer } = CartActions
      const { requestPermanentBackOrder } = PermanentBackOrderActions

      handleAppVersioning()

      // TODO: Remove these 4 lines
      // getProductsFromStorage(store);
      // saveProductsToStorage(store);
      // getCategoriesFromStorage(store);
      // saveCategoriesToStorage(store);

      // getCartFromStorage(store);
      // saveCartToStorage(store);

      store.dispatch(initializeSelectedFilters())

      // store.dispatch(getCategoryID());
      if (window.placeOnBehalfOfID) {
        getSupplierActiveCustomerFromStorage(store, window.placeOnBehalfOfID)
        saveSupplierActiveCustomerToStorage(store, window.placeOnBehalfOfID)
        /*
        if (cartSupplier) {
          store.dispatch(CartSupplierActions.requestFromServer())
        }
        */
      }
      Promise.all([
        store.dispatch(getUserWarehouseCode()),
        store.dispatch(getUserCredentials(), store.dispatch(getGlobalConfig())),
      ]).then(() => {
        if (window.isSubWholesaler || window.isWholesaler || window.isSuperWholesaler) {
          // store.dispatch(getUserCredentials(), store.dispatch(requestProductRules()))
          store.dispatch(requestProductRules())
        }
        /*
        if (cart) {
          store.dispatch(requestFromServer())
        }
        if (backOrder) {
          store.dispatch(requestPermanentBackOrder())
        }
        */
      })

      // 3PL Stuff
      if (window.supplierID) {
        get3plActiveCustomerFromStorage(store, window.supplierID)
        save3plActiveCustomerToStorage(store, window.supplierID)
      }

      // PaymentsHistory
      if (paymentsHistoryList) {
        initPaymentsHistory()
      }

      // Payments
      if (payments) {
        initPayments()
      }

      //View Statement Popup
      if (viewStatementPdf) {
        initViewStatementPdf()
      }

      // CocktailsList
      if (cocktailsList) {
        initCocktailsList()
      }
      if (freightCalculator) {
        initFreightCalculator()
      }

      if (threePlAdvancedShippingNotice) {
        initThreePlAdvancedShippingNotice()
      }

      if (threePlAdvancedShippingNoticeAdd) {
        initThreePlAdvancedShippingNoticeAdd()
      }

      if (threePlAdvancedShippingNoticeEdit) {
        initThreePlAdvancedShippingNoticeEdit()
      }

      if (threePlAdvancedShippingNoticeView) {
        initThreePlAdvancedShippingNoticeView()
      }

      if (threePlSupplierWeeklyOrderStats) {
        initThreePlSupplierWeeklyOrderStats()
      }

      if (transactionDetailInvoice) {
        initTransactionDetailInvoice()
      }

      if (billingChargesDetails) {
        initBillingDetailsReport()
      }

      if (threePlCreditTransactionDetails) {
        initThreePlCreditTransactionDetails()
      }

      if (threePlMyOrder) {
        initThreePlOrders()
      }

      if (threePlFreightCalculator) {
        initThreePlFreightCalculator()
      }
      // CocktailProductsList
      if (cocktailProductsList) {
        initCocktailProductsList()
      }

      // ProductForm
      if (productForm) {
        initProductForm()
      }

      // Invoices
      if (invoices) {
        initInvoices()
      }

      // Orders
      if (orders) {
        initOrders()
      }

      // OrderModal
      if (orderModal) {
        initOrderModal()
      }

      // InvoiceModal
      if (invoiceModal) {
        initInvoiceModal()
      }

      // Reports
      if (reports) {
        initReports()
      }

      // CocktailsModal
      if (cocktailsModal) {
        initCocktailsModal()
      }

      // ReplacementsModal
      if (replacementsModal) {
        initReplacementsModal()
      }

      // OrderTemplate
      if (orderTemplate) {
        initOrderTemplate()
      }

      // ProductsList
      if (productsList) {
        initProductsList()
      }

      // ProductsListPerPage
      if (productsListPerPage) {
        initProductsListPerPage()
      }

      if (productsListLoyalty) {
        initProductsLoyaltyListPerPage()
      }
      // ProductsListSearchPage
      if (productsListSearchPage) {
        initProductsListSearchPage()
      }

      // FeaturedProductList
      if (featuredProductList) {
        initFeaturedProductList()
      }

      // ProductsFilters
      if (productsFiltersTop || productsFiltersBottom) {
        initProductsFilters()
      }

      // ProductsPerPageFilters
      if (productsPerPageFilters || productsPerPageFiltersTop || productsPerPageFiltersBottom) {
        initProductsPerPageFilters()
      }

      // ProductGridTabs
      if (productGridTabs) {
        initProductGridTabs()
      }

      // Cart
      if (cart) {
        initCart()
      }

      //LoyaltyBoxModal
      if (loyaltyPopup) {
        initLoyaltyPopup()
      }
      if (userUpdatePopupCustomer) {
        initUserUpdatePopup()
      }

      if (orderConfirmationPage) {
        initOrderConfirmationPage()
      }

      // QLD out of business customer popup
      if (outOfBusinessCustomer) {
        initOutOfBusinessCustomer()
      }

      // QLD customer first login popup
      if (qldCustomerFirstPopup) {
        initQldCustomerFirstPopup()
      }

      // Cart Supplier
      if (cartSupplier) {
        getSupplierCartFromStorage(store)
        saveSupplierCartToStorage(store)
        initCartSupplier()
      }

      // Cart 3PL
      if (cart3PL) {
        get3plCartFromStorage(store)
        save3plCartToStorage(store)
        initCart3PL()
      }

      // BackOrder
      if (backOrder) {
        initBackOrder()
      }

      // CartCounter
      if (cartCounter) {
        initCartCounter()
      }

      // CartCounterSupplier
      if (cartCounterSupplier) {
        initCartCounterSupplier()
      }

      // CartCounter3PL
      if (cartCounter3PL) {
        initCartCounter3PL()
      }

      // BackOrderCounter
      if (backOrderCounter) {
        initBackOrderCounter()
      }

      // ProductMaintenanceList
      if (productMaintenanceList) {
        initProductMaintenanceList()
      }

      // ProductMaintenanceModalEdit
      if (productMaintenanceModalEdit) {
        initProductMaintenanceModalEdit()
      }

      // ProductMaintenanceModalAdd
      if (productMaintenanceModalAdd) {
        initProductMaintenanceModalAdd()
      }
      if (threePlProductMaintenanceAdd) {
        initThreePlProductMaintenanceAdd()
      }
      // Discounts
      if (discountsList) {
        initDiscounts()
      }

      // DiscountForm
      if (discountForm) {
        initDiscountForm()
      }

      // DiscountModal
      if (discountModal) {
        initDiscountModal()
      }

      // PromotionForm
      if (promotionForm) {
        initPromotionForm()
      }

      // DealBuilderForm
      if (dealBuilderForm) {
        initDealBuilderForm()
      }

      // DealBuilderList
      if (dealBuilderList) {
        initDealBuilderList()
      }

      //DealBuilderEdit
      if (dealBuilderEdit) {
        initDealBuilderEdit()
      }

      // DealBuilderModal
      if (dealBuilderModalView) {
        initDealBuilderModal()
      }

      // PromotionList
      if (promotionList) {
        initPromotionList()
      }

      // OngoingDeal
      if (ongoingDeal) {
        initOngoingDeal()
      }

      // OngoingDealModal
      if (ongoingDealModal) {
        initOngoingDealModal()
      }

      // Orders3PL
      if (orders3pl) {
        initOrders3PL()
      }

      // Order3PLModal
      if (order3plModal) {
        initOrder3PLModal()
      }

      // CustomerBar
      if (customerBar) {
        initCustomerBar()
      }

      // CustomerBar3PL
      if (customerBar3PL) {
        initCustomerBar3PL()
      }

      // SearchSupplierForm
      if (searchSupplierForm) {
        initSearchSupplierForm()
      }

      // SearchCustomerForm
      if (searchCustomerForm) {
        initSearchCustomerForm()
      }

      // SearchCustomerForm3PL
      if (searchCustomerForm3PL) {
        initSearchCustomerForm3PL()
      }

      // SearchCustomerFormSuperWholesaler
      if (searchCustomerFormSuperWholesaler) {
        initSearchCustomerFormSuperWholesaler()
      }

      // CustomerManagement
      if (customerManagementList) {
        initCustomerManagement()
      }

      // ProductsList3PL
      if (productsList3PL) {
        initProductsList3PL()
      }

      // PlaceOrderButton3PL
      if (placeOrderButton3PL) {
        initPlaceOrderButton3PL()
      }

      // ProductsListSupplier
      if (productsListSupplier) {
        initProductsListSupplier()
      }

      // SupplierAddAll
      if (supplierAddAll) {
        initAddAllToOrderButton()
      }

      // Checkout
      if (checkout) {
        initCheckout()
      }

      // CheckoutSupplier
      if (checkoutSupplier) {
        initCheckoutSupplier()
      }

      // Checkout3PL
      if (checkout3pl) {
        initCheckout3PL()
      }

      // Checkout3PL
      if (checkoutConfirmDeliveryDate) {
        initCheckoutConfirmDeliveryDate()
      }

      // OrderReceiptTable
      if (orderReceiptTable) {
        initOrderReceiptTable()
      }

      // AccountListAddress
      if (accountListAddress) {
        initAccountListAddress()
      }

      // AccountNewAddress
      if (accountNewAddress) {
        initAccountNewAddress()
      }

      // AccountListCreditCard
      if (accountListCreditCard) {
        initAccountListCreditCard()
      }

      // AccountNewCreditCard
      if (accountNewCreditCard) {
        initAccountNewCreditCard()
      }

      // SupplierHistoryReport
      if (supplierHistoryReport) {
        initSupplierHistoryReport()
      }

      // SupplierStockReport
      if (supplierStockReport) {
        initSupplierStockReport()
      }

      // SupplierSalesReport
      if (supplierSalesReport) {
        initSupplierSalesReport()
      }

      // SupplierBinTransReport
      if (supplierBinTransReport) {
        initSupplierBinTransReport()
      }

      // SupplierRateCard
      if (supplierRateCard) {
        initSupplierRateCard()
      }

      // SupplierRateCardList
      if (supplierRateCardList) {
        initSupplierRateCardList()
      }

      if (wholesaleSupplierCPIReport) {
        initWholesaleSupplierSubmitCPIReport()
      }

      if (threePLSupplierCPIReport) {
        init3PLWholesaleSupplierSubmitCPIReport()
      }

      /////////////////////////
      //RCTI and Billing Reports

      if (threeplRctiDollarDailyCharge) {
        initThreeplRctiDollarDailyCharge()
      }

      if (threeplBillingDollarCharge) {
        initThreeplBillingDollarCharge()
      }

      if (threeplRctiPercentageCharge) {
        initThreeplRctiPercentageCharge()
      }

      if (threeplBillingPercentageCharge) {
        initThreeplBillingPercentageCharge()
      }

      // Supplier Purchases Report
      if (threeplSupplierPurchasesReport) {
        initThreeplSupplierPurchasesReport()
      }
      ///////////////////////////
      //////////////////////////

      // SupplierOutOfStockReport
      if (supplierOutOfStockReport) {
        initSupplierOutOfStockReport()
      }

      // SupplierSalesVenueReport
      if (supplierSalesVenueReport) {
        initSupplierSalesVenueReport()
      }
      //Backorder checkboxes
      if (backorderDropdown) {
        initBackorderDropdown()
      }

      if (productCarousels) {
        for (let i = 0; i < productCarousels.length; i++) {
          initProductCarousel(productCarousels.item(i), productCarousels.item(i).dataset.blockId)
        }
      }

      if (productSliderList) {
        for (let i = 0; i < productSliderList.length; i++) {
          initProductSlider(productSliderList.item(i), productSliderList.item(i).dataset.blockId)
        }
      }

      //New My accounts sections
      if (deliveryInformation) {
        initDeliveryInformation()
      }

      if (backorderSms) {
        initBackorderSms()
      }

      if (backorderNotification) {
        initBackorderNotification()
      }

      if (wholesaleSupplierInvoiceSearch) {
        initWholesaleSupplierInvoiceSearch()
      }

      if (featuresDeals) {
        initFeaturesDeals()
      }

      if (accountPayable) {
        initAccountPayable()
      }

      // Delivery Preferences
      if (deliveryPreferences) {
        initDeliveryPreferences()
      }

      if (eventEnquirySignup) {
        initEventEnquirySignup()
      }

      if (confirmDeliveryPopup) {
        initConfirmDeliveryPopup()
      }

      if (quoteTemplateList) {
        initQuoteTemplateList()
      }

      if (createSaleQuote) {
        initCreateSaleQuote()
      }

      if (editSaleQuote) {
        initEditSaleQuote()
      }

      if (editSaleQuoteManager) {
        initEditSaleQuoteManager()
      }

      if (quoteStatus) {
        initQuoteStatus()
      }
      if (dealBtn) {
        console.log('deals showing')
        initDealButton
      }

      if (threeplproductMaintenanceList) {
        init3PLProductMaintenanceList()
      }
      if (threeplCustomersList) {
        init3PLCustomersList()
      }

      if (threeplstockOnHandList) {
        init3PLStockOnHandList()
      }
      if (threeplatRiskStockList) {
        init3PLAtRiskStockList()
      }

      if (threeplcreditAccountList) {
        init3PLCreditAccountList()
      }

      if (threeplsubmittedDealList) {
        init3PLSubmittedDealList()
      }

      if (chartDocument) {
        initChartDocument()
      }

      if (surveyForm) {
        initSurveyForm()
      }
      if (marketingSurveyForm) {
        initMarketingSurveyForm()
      }

      if (loyaltyBoxModal) {
        initLoyaltyBoxModal()
      }

      if (productListingGridBlock) {
        if (productListingGridBlock) {
          for (let i = 0; i < productListingGridBlock.length; i++) {
            initProductListingGridBlock({
              productListingGridBlockItem: productListingGridBlock.item(i),
              blockId: productListingGridBlock.item(i).dataset.blockid,
              itemsLimit: productListingGridBlock.item(i).dataset.itemslimit,
              productTilesJSON: productListingGridBlock.item(i).dataset.listjson,
            })
          }
        }
      }
    }
  )
}
const initDOM = () => {
  Promise.all([
    import(/* webpackChunkName: "jQuery" */ 'jquery'),
    import(/* webpackChunkName: "@sentry/react" */ '@sentry/react'),
    import(/* webpackChunkName: "@sentry/tracing" */ '@sentry/tracing'),
    import(/* webpackChunkName: "utils" */ '_utils'),
    import(/* webpackChunkName: "bootstrap" */ 'bootstrap'),
    import(/* webpackChunkName: "slick" */ 'slick'),
  ]).then(([{ default: $ }, Sentry, SentryTracing, { scrollToLocationHash }]) => {
    /* Sentry integration for catching React errors */
    const { BrowserTracing } = SentryTracing
    const SENTRY_DSN = 'https://c9d93d59b3d0467187919204e9c30887@sentry.visualr.dev//12'
    Sentry.init({
      dsn: SENTRY_DSN,
      // We recommend adjusting this value in production, or using tracesSampler
      // for finer control
      integrations: [new BrowserTracing()],
      tracesSampleRate: 1,
      release: '4.36.0',
      environment: 'Prepod',
      // debug: false,
      // initialScope: {
      //     user: { id: 42, email: "john.doe@example.com" },
      // },
    })

    $('body').removeClass('preload')
    $('.backtotop').click(function () {
      $('html, body').animate({ scrollTop: 0 }, 800)
    })
    $('.loginButton').click(function () {
      $('html, body').animate(
        {
          scrollTop: $('#logIn').offset().top - 120,
        },
        10
      )
    })
    var section = $('.accordian--holder li')
    var width = $(window).width()
    section.removeClass('active')
    $('.accordian--holder li:first-child').addClass('active')
    function toggleAccordion() {
      if (width < 992) {
        if ($(this).hasClass('active')) {
          $(this).removeClass('active')
        } else {
          section.removeClass('active')
          $(this).addClass('active')
        }
      } else {
        section.removeClass('active')
        $(this).addClass('active')
      }
    }

    section.on('click', toggleAccordion)
    // if (window?.showPlaceOnBehalfPopup) {
    //   $('#switch-user-modal').modal('show')
    // }
    var myItems = document.querySelectorAll('a[scrollTo]')
    function scrollView() {
      var targetId = this.getAttribute('scrollTo')
      if (targetId && targetId !== 'top') {
        var targetElement = document.getElementById(targetId)
        const yOffset = -25
        const y = targetElement?.getBoundingClientRect()?.top + window?.pageYOffset + yOffset
        window?.scrollTo({ top: y, behavior: 'smooth' })
      } else {
        window?.scrollTo({ top: 0, behavior: 'smooth' })
      }
    }

    myItems.forEach((item) => item.addEventListener('click', scrollView))

    const items = document.querySelectorAll('.credits-accordion button')
    function toggleMenuAccordion() {
      const itemToggle = this.getAttribute('aria-expanded')
      for (i = 0; i < items.length; i++) {
        items[i].setAttribute('aria-expanded', 'false')
      }
      if (itemToggle == 'false') {
        this.setAttribute('aria-expanded', 'true')
        let changeMenuId = this.getAttribute('id')
        let menuTitle = this.getAttribute('title')
        // toggleMenuList(changeMenuId)
        // item.setAttribute('class', 'active-accord')
      }
      $('.accordion-item').removeClass('unlock--accordian')
    }
    items.forEach((item) => item.addEventListener('click', toggleMenuAccordion))

    $(document).click(function (e) {
      if (!$(e.target).is('.filter-list__link')) {
        $('#oT-1').collapse('hide')
      }
    })

    //   var progressBarOptions = {
    //     startAngle: -1.55,
    //     size: 350,
    //     thickness:40,
    //     value: window.percentageVal/100,
    //     fill: {
    //         color: window.currentTiler === 'bronze' ? '#ffa500' : window.currentTiler === 'gold' ? '#CAB440' : window.currentTiler === 'platinum' ? '#4C4C4C'  : window.currentTiler === 'silver' ? '#B3B3B3' : '#CD7F32'
    //     }
    // }

    // $('.circle').circleProgress(progressBarOptions).on('circle-animation-progress', function(event, progress, stepValue) {
    //     $(this).find('strong').text(String(stepValue.toFixed(2)).substr(1));
    // });

    const itemsList = document.querySelectorAll('.credits-accordion button')
    function toggleAccordianwithmenu(id) {
      let item
      for (i = 0; i < itemsList.length; i++) {
        itemsList[i].setAttribute('aria-expanded', 'false')
        if (itemsList[i].getAttribute('id') == id) {
          item = itemsList[i]
        }
      }
      const itemToggle = item?.getAttribute('aria-expanded')
      if (itemToggle == 'false') {
        item?.setAttribute('aria-expanded', 'true')
        item.setAttribute('class', 'active-accord')
        $('.accordion-item .active-accord').parent('.accordion-item').prevAll().addClass('unlock--accordian')
      }
    }

    console.log('window.windowCurrentLevel', window.windowCurrentLevel)
    // $('.circular--list--holder').hide()
    if (window.windowCurrentLevel === 'bronze') {
      toggleAccordianwithmenu('section1')
      $('.card-image').removeClass('showImage')
      $('#section1.circular--list--holder').addClass('active')
      $('.bg--holder--status--credit').removeClass('platinum--holder')
      $('.bg--holder--status--credit').removeClass('gold--holder')
      $('.bg--holder--status--credit').removeClass('silver--holder')
      $('.bg--holder--status--credit').addClass('bronze--holder')
      $('#section1.card-image').addClass('showImage')
    }
    if (window.windowCurrentLevel === 'silver') {
      toggleAccordianwithmenu('section2')
      $('.card-image').removeClass('showImage')
      $('#section2.circular--list--holder').addClass('active')
      $('.bg--holder--status--credit').removeClass('platinum--holder')
      $('.bg--holder--status--credit').removeClass('gold--holder')
      $('.bg--holder--status--credit').addClass('silver--holder')
      $('.bg--holder--status--credit').removeClass('bronze--holder')
      $('#section2.card-image').addClass('showImage')
    }
    if (window.windowCurrentLevel === 'gold') {
      toggleAccordianwithmenu('section3')
      $('.card-image').removeClass('showImage')
      $('#section3.circular--list--holder').addClass('active')
      $('.bg--holder--status--credit').removeClass('platinum--holder')
      $('.bg--holder--status--credit').addClass('gold--holder')
      $('.bg--holder--status--credit').removeClass('silver--holder')
      $('.bg--holder--status--credit').removeClass('bronze--holder')
      $('#section3.card-image').addClass('showImage')
    }
    if (window.windowCurrentLevel === 'platinum') {
      toggleAccordianwithmenu('section4')
      $('.card-image').removeClass('showImage')
      $('#section4.circular--list--holder').addClass('active')
      $('.bg--holder--status--credit').addClass('platinum--holder')
      $('.bg--holder--status--credit').removeClass('gold--holder')
      $('.bg--holder--status--credit').removeClass('silver--holder')
      $('.bg--holder--status--credit').removeClass('bronze--holder')
      $('#section4.card-image').addClass('showImage')
    }
    // $('.circular--list--holder:first-child').addClass('active');
    // $('.circular--list--holder').click(toggleMenuList)

    // function toggleMenuList(menuId) {
    //   console.log($(this))
    //   $('.circular--list--holder').removeClass('active')

    //   if (menuId && typeof menuId == 'string') {
    //     console.log('called inside menuId if ', menuId)
    //     let listItems = document.querySelectorAll('.circular--list--holder')
    //     let myItem
    //     for (i = 0; i < listItems.length; i++) {
    //       if (listItems[i]?.getAttribute('id') == menuId) {
    //         myItem = listItems[i]
    //       }
    //     }
    //     if (myItem) {
    //       // $(myItem)?.next()?.next('.circular--list--holder')?.addClass('active')
    //       $(myItem)?.addClass('active')
    //       if ($(myItem).attr('id') == 'section1') {
    //         // toggleAccordianwithmenu('section2')
    //         $('.card-image').removeClass('showImage')
    //         $('.pointsText').text(window.currentBronze)
    //         $('.nextLevelText').text('Bronze')
    //         $('.bg--holder--status--credit').removeClass('silver--holder')
    //         $('.bg--holder--status--credit').removeClass('gold--holder')
    //         $('.bg--holder--status--credit').removeClass('platinum--holder')
    //         $('.bg--holder--status--credit').addClass('bronze--holder')
    //         $('#section1.card-image').addClass('showImage')
    //       }
    //       if ($(myItem).attr('id') == 'section2') {
    //         // toggleAccordianwithmenu('section3')
    //         $('.card-image').removeClass('showImage')
    //         $('.pointsText').text(window.currentSilver)
    //         $('.nextLevelText').text('Silver')
    //         $('.bg--holder--status--credit').removeClass('bronze--holder')
    //         $('.bg--holder--status--credit').addClass('silver--holder')
    //         $('.bg--holder--status--credit').removeClass('platinum--holder')
    //         $('.bg--holder--status--credit').removeClass('gold--holder')
    //         $('#section2.card-image').addClass('showImage')
    //       }
    //       if ($(myItem).attr('id') == 'section3') {
    //         // toggleAccordianwithmenu('section4')
    //         $('.card-image').removeClass('showImage')
    //         $('.pointsText').text(window.currentGold)
    //         $('.nextLevelText').text('Gold')
    //         $('.bg--holder--status--credit').removeClass('bronze--holder')
    //         $('.bg--holder--status--credit').removeClass('silver--holder')
    //         $('.bg--holder--status--credit').addClass('gold--holder')
    //         $('.bg--holder--status--credit').removeClass('platinum--holder')
    //         $('#section3.card-image').addClass('showImage')
    //       }
    //       if ($(myItem).attr('id') == 'section4') {
    //         // toggleAccordianwithmenu('section1')
    //         $('.card-image').removeClass('showImage')
    //         $('.pointsText').text(window.currentPlatinum)
    //         $('.nextLevelText').text('Platinum')
    //         $('.bg--holder--status--credit').addClass('platinum--holder')
    //         $('.bg--holder--status--credit').removeClass('silver--holder')
    //         $('.bg--holder--status--credit').removeClass('gold--holder')
    //         $('.bg--holder--status--credit').removeClass('bronze--holder')
    //         $('#section4.card-image').addClass('showImage')
    //       }
    //     }
    //   } else {
    //     console.log('called inside menuId if else ')
    //     $(this).next().next('.circular--list--holder').addClass('active')
    //     $(this).next().addClass('active')
    //     if ($(this).attr('id') == 'section1' && $('.bg--holder--status--credit').hasClass('bronze--holder')) {
    //       toggleAccordianwithmenu('section2')
    //       $('.card-image').removeClass('showImage')
    //       $('.pointsText').text(window.currentGold)
    //       $('.nextLevelText').text('Gold')
    //       $('.bg--holder--status--credit').addClass('silver--holder')
    //       $('.bg--holder--status--credit').removeClass('gold--holder')
    //       $('.bg--holder--status--credit').removeClass('platinum--holder')
    //       $('.bg--holder--status--credit').removeClass('bronze--holder')
    //       $('#section2.card-image').addClass('showImage')
    //     }
    //     if ($(this).attr('id') == 'section2') {
    //       toggleAccordianwithmenu('section3')
    //       $('.card-image').removeClass('showImage')
    //       $('.pointsText').text(window.currentPlatinum)
    //       $('.nextLevelText').text('Platinum')
    //       $('.bg--holder--status--credit').removeClass('bronze--holder')
    //       $('.bg--holder--status--credit').removeClass('bronze--holder')
    //       $('.bg--holder--status--credit').removeClass('platinum--holder')
    //       $('.bg--holder--status--credit').addClass('gold--holder')
    //       $('#section3.card-image').addClass('showImage')
    //     }
    //     if ($(this).attr('id') == 'section3') {
    //       toggleAccordianwithmenu('section4')
    //       $('.card-image').removeClass('showImage')
    //       $('.pointsText').text(window.currentSilver)
    //       $('.nextLevelText').text('Silver')
    //       $('.bg--holder--status--credit').removeClass('bronze--holder')
    //       $('.bg--holder--status--credit').removeClass('silver--holder')
    //       $('.bg--holder--status--credit').removeClass('gold--holder')
    //       $('.bg--holder--status--credit').addClass('platinum--holder')
    //       $('#section4.card-image').addClass('showImage')
    //     }
    //     if ($(this).attr('id') == 'section4') {
    //       toggleAccordianwithmenu('section1')
    //       $('.card-image').removeClass('showImage')
    //       $('.pointsText').text(window.currentGold)
    //       $('.nextLevelText').text('Gold')
    //       $('.bg--holder--status--credit').removeClass('platinum--holder')
    //       $('.bg--holder--status--credit').removeClass('silver--holder')
    //       $('.bg--holder--status--credit').removeClass('gold--holder')
    //       $('.bg--holder--status--credit').addClass('bronze--holder')
    //       $('#section1.card-image').addClass('showImage')
    //     }
    //   }
    //   // $('.pointsText').text(window.currentSilver);

    //   // $('.pointsText').text(window.currentPlatinum);

    //   if (!$('.circular--list--holder').hasClass('active')) {
    //     $('.circular--list--holder:first-child').addClass('active')
    //   }
    // }
    $(document).ready(function () {
      let currentPath = window.location.pathname
      let localPath = 'http://localhost:8080/supplier'
      let preprodPath = 'http://paramount.visualr.dev/supplier'
      let prodPath = 'https://www.paramountliquor.com.au/'
      if (currentPath === '/supplier/submit-cpi-report/' && (window.isSubSupplier || window.is3PLSubSupplier)) {
        window.location.href = preprodPath // Redirect to the dashboard page.
      }
      if (currentPath === '/supplier/submit-cpi-report/' && window.is3PLSubSupplier) {
        window.location.href = preprodPath // Redirect to the dashboard page.
      }
      var toast = document.querySelector('.redirected-message')
      if (toast) {
        toast.style.display = 'block' // show the toast
        setTimeout(() => {
          toast.style.opacity = '1' // fade in
        }, 100)

        // hide the toast after 5 seconds (5000 milliseconds)
        setTimeout(function () {
          toast.style.opacity = '0' // fade out
          setTimeout(() => {
            toast.style.display = 'none' // hide it after the fade out
          }, 300) // This value should match the CSS transition duration
        }, 5000)
      }
      $(window).scroll(function () {
        if ($(window).scrollTop() >= 250) {
          $('.react-table .rt-thead').addClass('fixed-table-header')
        } else {
          $('.react-table .rt-thead').removeClass('fixed-table-header')
        }
      })

      $('.feature-items-container').slick({
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        arrows: true,
        // centerMode: true,
        centerPadding: '60px',
        responsive: [
          {
            breakpoint: 992,
            settings: {
              autoplay: false,
              slidesToShow: 3,
              centerPadding: '10px',
              slidesToScroll: 3,
            },
          },
        ],
      })
    })

    setTimeout(function () {
      scrollToLocationHash()

      if ($('#outstanding-balance-modal').length > 0) {
        $('#outstanding-balance-modal').modal('show')
      }
    }, 1000)
  })
}
import(/* webpackChunkName: "Login" */ '../main/dom/login').then((Login) => Login.binds())
import(/* webpackChunkName: "Cart" */ 'dom/cart').then((Cart) => Cart.binds())
import(/* webpackChunkName: "Stock" */ 'dom/stock').then((Stock) => Stock.binds())
import(/* webpackChunkName: "Promotions" */ 'dom/promotions').then((Promotions) => Promotions.binds())
import(/* webpackChunkName: "Field" */ 'dom/field').then((Field) => Field.binds())
import(/* webpackChunkName: "FieldAddress" */ 'dom/field--address').then((FieldAddress) => FieldAddress.binds())
import(/* webpackChunkName: "Form" */ 'dom/form').then((Form) => Form.binds())
import(/* webpackChunkName: "Menu" */ 'dom/menu').then((Menu) => Menu.binds())
import(/* webpackChunkName: "Modal" */ 'dom/modal').then((Modal) => Modal.binds())
import(/* webpackChunkName: "PopupManager" */ 'dom/popup-manager').then((PopupManager) => PopupManager.binds())
import(/* webpackChunkName: "BannerManager" */ 'dom/banner-manager').then((BannerManager) => BannerManager.binds())
import(/* webpackChunkName: "ProductsGallery" */ 'dom/products-gallery').then((ProductsGallery) =>
  ProductsGallery.binds()
)
import(/* webpackChunkName: "ProductsBanner" */ 'dom/products-banner').then((ProductsBanner) => ProductsBanner.binds())
import(/* webpackChunkName: "Products" */ 'dom/products').then((Products) => Products.binds())
import(/* webpackChunkName: "Sidebar" */ 'dom/sidebar').then((Sidebar) => Sidebar.binds())
import(/* webpackChunkName: "Slider" */ 'dom/slider').then((Slider) => Slider.binds())
import(/* webpackChunkName: "Window" */ 'dom/window').then((Window) => Window.binds())
import(/* webpackChunkName: "DashboardWholesale" */ 'dom/dashboard--wholesale').then((DashboardWholesale) =>
  DashboardWholesale.binds()
)
import(/* webpackChunkName: "AccountDetails" */ 'dom/account-details').then((AccountDetails) => AccountDetails.binds())

const paymentsHistoryList = document.getElementById('payments-history-list')
const payments = document.getElementById('payments-list')
const viewStatementPdf = document.getElementById('view-statement-pdf')
const cocktailsList = document.getElementById('cocktails-list')
const cocktailProductsList = document.getElementById('cocktail-products-list')
const productForm = document.getElementById('product-form')
const invoices = document.getElementById('invoices-list')
const orders = document.getElementById('orders-list')
const orderModal = document.getElementById('view-order-modal')
const invoiceModal = document.getElementById('view-invoice-modal')
const reports = document.getElementById('reports-list')
const cocktailsModal = document.getElementById('cocktail-modal')
const replacementsModal = document.getElementById('replacements-modal')
const orderTemplate = document.getElementById('order-template-list')
const productsList = document.getElementById('products-list')
const productsListPerPage = document.getElementById('products-list-per-page')
const productsListLoyalty = document.getElementById('products-list-loyalty')
const wholesaleSupplierInvoiceSearch = document.getElementById('search-invoice-page')
const productsListSearchPage = document.getElementById('products-list-search-page') // for search page
const featuredProductList = document.getElementById('featured-product-list')
const productsFiltersTop = document.getElementById('products-filters-top')
const productsFiltersBottom = document.getElementById('products-filters-bottom')
const wholesaleSupplierCPIReport = document.getElementById('submit-cpi-report')
const threePLSupplierCPIReport = document.getElementById('3pl-submit-cpi-report')

const productsPerPageFilters = document.getElementById('products-per-page-filters')
const productsPerPageFiltersTop = document.getElementById('products-per-page-filters-top')
const productsPerPageFiltersBottom = document.getElementById('products-per-page-filters-bottom')
const productGridTabs = document.getElementById('product-grid-modal-tabs')
const loyaltyPopup = document.getElementById('loyalty-popup')
const cart = document.getElementById('cart-order')
const cartSupplier = document.getElementById('cart-order-supplier')
const cart3PL = document.getElementById('cart-order-3pl')
const backOrder = document.getElementById('cart-backorder')
const cartCounter = document.querySelectorAll('.cart-counter-wholesale')
const cartCounterSupplier = document.querySelectorAll('.cart-counter-supplier')
const cartCounter3PL = document.querySelectorAll('.cart-counter-3pl')
const backOrderCounter = document.querySelectorAll('.back-order-counter')
const productMaintenanceList = document.getElementById('product-maintenance-list')
const threeplstockOnHandList = document.getElementById('3pl-stock-on-hand-list')
const threeplatRiskStockList = document.getElementById('3pl-at-risk-stock-list')
const threeplproductMaintenanceList = document.getElementById('3pl-product-maintenance-list')
const threeplCustomersList = document.getElementById('3pl-customers-list')
const threeplsubmittedDealList = document.getElementById('3pl-submitted-deal-list')
const threeplcreditAccountList = document.getElementById('3pl-credit-account-list')
const productMaintenanceModalEdit = document.getElementById('edit-product-modal')
const productMaintenanceModalAdd = document.getElementById('add-product-modal')
const threePlProductMaintenanceAdd = document.getElementById('add-threepl-product')
const discountsList = document.getElementById('discounts-list')
const discountForm = document.getElementById('copy-discount-modal')
const discountModal = document.getElementById('view-discount-modal')
const promotionForm = document.getElementById('promotion-form')
const promotionList = document.getElementById('promotion-list')
const dealBuilderForm = document.getElementById('deal-builder-form')
const dealBuilderList = document.getElementById('deal-builder-list')
const dealBuilderEdit = document.getElementById('deal-builder-edit')
const dealBuilderModalView = document.getElementById('view-deal-builder-modal')
const ongoingDeal = document.getElementById('ongoing-deal-list')
const ongoingDealModal = document.getElementById('ongoing-deal-list-modal')
const orders3pl = document.getElementById('order-status-list')
const order3plModal = document.getElementById('view-order-3pl-modal')
const searchSupplierForm = document.getElementById('search-supplier-form')
const searchCustomerForm = document.getElementById('search-customer-form')
const searchCustomerForm3PL = document.getElementById('search-customer-form-3pl')
const searchCustomerFormSuperWholesaler = document.getElementById('search-customer-form-super-wholesaler')
const customerBar = document.getElementById('customer-bar')
const customerBar3PL = document.getElementById('customer-bar-3pl')
const customerManagementList = document.getElementById('customer-management-list')
const productsList3PL = document.getElementById('3pl-orders-list')
const placeOrderButton3PL = document.getElementById('3pl-place-order')
const productsListSupplier = document.getElementById('place-order-list')
const supplierAddAll = document.getElementById('supplier-add-all')
const checkout = document.getElementById('checkout')
const checkoutSupplier = document.getElementById('checkout-supplier')
const checkout3pl = document.getElementById('checkout-3pl')
const orderReceiptTable = document.getElementById('order-receipt')
const accountListCreditCard = document.getElementById('account-list-credit-card')
const accountNewCreditCard = document.getElementById('account-new-credit-card')
const accountListAddress = document.getElementById('account-list-address')
const accountNewAddress = document.getElementById('account-new-address')
const checkoutConfirmDeliveryDate = document.getElementById('confirm-delivery-date')
const supplierHistoryReport = document.getElementById('supplier-history-report')
const supplierStockReport = document.getElementById('supplier-stock-report')
const supplierSalesReport = document.getElementById('supplier-sales-report')
const supplierBinTransReport = document.getElementById('supplier-bin-trans-report')
const supplierRateCard = document.getElementById('3pl-supplier-rate-card-report')
const supplierRateCardList = document.getElementById('3pl-supplier-rate-card-list')
const threeplRctiDollarDailyCharge = document.getElementById('3pl-rcti-dollar-daily-charge')
const threeplBillingDollarCharge = document.getElementById('3pl-billing-dollar-charge')
const threeplRctiPercentageCharge = document.getElementById('3pl-rcti-percentage-charge')
const threeplBillingPercentageCharge = document.getElementById('3pl-billing-percentage-charge')
const threeplSupplierPurchasesReport = document.getElementById('3pl-supplier-purchases-report')
const supplierOutOfStockReport = document.getElementById('3pl-supplier-out-of-stock')
const supplierSalesVenueReport = document.getElementById('supplier-sales-venue-report')
const backorderDropdown = document.getElementById('backorder-dropdown')
const productCarousels = document.getElementsByClassName('product-carousel')
const productSliderList = document.getElementsByClassName('product-slider-list')
const eventEnquirySignup = document.getElementById('signup-react')
const confirmDeliveryPopup = document.getElementById('confirm-delivery-react')
const backorderSms = document.getElementById('backorder-sms')
const deliveryInformation = document.getElementById('delivery-information')
const backorderNotification = document.getElementById('backorder-notification')
const featuresDeals = document.getElementById('features-deals')
const accountPayable = document.getElementById('account-payable')
const deliveryPreferences = document.getElementById('delivery-preferences')
const quoteTemplateList = document.getElementById('quote-template-list')
const createSaleQuote = document.getElementById('create-sale-quote')
const editSaleQuote = document.getElementById('edit-sale-quote')
const editSaleQuoteManager = document.getElementById('edit-sale-quote-manager')
const quoteStatus = document.getElementById('quote-status-success')
const dealBtn = document.getElementById('deal-btn')
const freightCalculator = document.getElementById('freight-calculator')
const threePlMyOrder = document.getElementById('threepl-orders')
const threePlAdvancedShippingNotice = document.getElementById('threepl-advanced-shipping-notice')
const threePlAdvancedShippingNoticeAdd = document.getElementById('threepl-advanced-shipping-notice-add')
const threePlAdvancedShippingNoticeView = document.getElementById('threepl-advanced-shipping-notice-view')
const threePlAdvancedShippingNoticeEdit = document.getElementById('threepl-advanced-shipping-notice-edit')
const threePlFreightCalculator = document.getElementById('threepl-freight-calculator')
const chartDocument = document.getElementById('chart-document')
const googleAddressChecker = document.getElementById('google-address-checker')
const surveyForm = document.getElementById('core-form-builder')
const marketingSurveyForm = document.getElementById('marketing-form-builder')
const loyaltyBoxModal = document.getElementById('loyalty-box-modal')
const productListingGridBlock = document.getElementsByClassName('product-listing-grid-block')
const orderConfirmationPage = document.getElementById('order-confirmation-page-react')
const qldCustomerFirstPopup = document.getElementById('qld-customer-first-popup')
const outOfBusinessCustomer = document.getElementById('out-of-business-customer')
const threePlSupplierWeeklyOrderStats = document.getElementById('3pl-supplier-weekly-order-stats')
const threePlCreditTransactionDetails = document.getElementById('3pl-credit-account-rcti-transaction-detail')
const transactionDetailInvoice = document.getElementById('3pl-billing-charges-by-invoice')
const billingChargesDetails = document.getElementById('3pl-supplier-billing-charges')
const userUpdatePopupCustomer = document.getElementById('user-update-popup-customer')
initDOM()
initStore()
